import { render, staticRenderFns } from "./PartPopupDelete.vue?vue&type=template&id=04bcbd9e&scoped=true&"
import script from "./PartPopupDelete.vue?vue&type=script&lang=js&"
export * from "./PartPopupDelete.vue?vue&type=script&lang=js&"
import style0 from "./PartPopupDelete.vue?vue&type=style&index=0&id=04bcbd9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bcbd9e",
  null
  
)

export default component.exports